import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'shared/components/modal';
import Image1 from 'shared/img/parent-welcome-modal-image-1.svg';
import Image2 from 'shared/img/parent-welcome-modal-image-2.svg';
import Image3 from 'shared/img/parent-welcome-modal-image-3.svg';

export default class WelcomeModal extends React.Component {
  static propTypes = {
    handleClose: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      step: 0,
    };
  }

  onNextClick = () => {
    if (this.state.step === 2) {
      this.props.handleClose();
    } else {
      this.setState({step: this.state.step + 1});
    }
  };

  onBackClick = () => {
    this.setState({step: this.state.step - 1});
  };

  getModalContent() {
    const {step} = this.state;

    const modalContent = {title: 'Welcome to the Parent Portal'};

    switch (step) {
      case 0:
        modalContent.text = 'View your connected students and pending connections.';
        modalContent.ModalImage = Image1;
        break;
      case 1:
        modalContent.ModalImage = Image2;
        modalContent.text = 'Manage and edit your student’s Raise Me account in Student Mode.';
        break;
      case 2:
        modalContent.ModalImage = Image3;
        modalContent.text = 'Learn more about financial aid and how Raise Me works.';
        break;
    }

    return modalContent;
  }

  render() {
    const {ModalImage, title, text} = this.getModalContent();
    const secondaryButton =
      this.state.step === 0 ? null : {onClick: this.onBackClick, text: 'Back', width: 85};

    return (
      <Modal show>
        <Modal.ImageHeader
          onClose={this.props.handleClose}
          backgroundImage={ModalImage}
          backgroundColor="m400"
          color="white"
          height="tall"
        >
          {title}
        </Modal.ImageHeader>
        <Modal.Body>{text}</Modal.Body>
        <Modal.NavigationFooter
          primaryButton={{
            onClick: this.onNextClick,
            width: 85,
            text: this.state.step === 2 ? 'Done' : 'Next',
          }}
          stepCount={3}
          currentStep={this.state.step}
          secondaryButton={secondaryButton}
        />
      </Modal>
    );
  }
}
